import {config} from "../../../../../src/enviroment";
import {apolloClientService} from '../../../../services/apollo-client'

export default async function getBillComparison(saId, accountId){
  let bearer = localStorage.getItem("bearer");
  let personId = "";
  let tenantCode = config.constants.BASE_TENANT_CODE;
  if (bearer) {
    bearer = JSON.parse(bearer);
    personId = bearer.personId;
  }
    let APIquery =`{
      getBillComparison(input: {
         numBills: "2"
      }) { 
          endingBalance
          billDate   
      }
  }`;
        let headers={
            accountId: accountId,
            saId: saId,
            tenantCode:tenantCode
          }   
    return await apolloClientService.ApolloClientgqlsUsage(APIquery,headers);
}